import barba from '@barba/core';
import { gsap } from '@gsap/shockingly';
import { ScrollTrigger } from '@gsap/shockingly/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const ajaxNav = {
	ui: {},

	init: function() {
		barba.init({
			//prefetchIgnore: true,
			prevent: ({ el, event }) => {
				if (event.type === 'click') {
					if (el.classList && el.classList.contains('js-ajax-previous') && barba.history.previous) {
						event.preventDefault();
						return true;
					}

					let $wp_admin_bar = document.getElementById('wpadminbar');
					if (typeof $wp_admin_bar != "undefined" && $wp_admin_bar != null) {
						if ($wp_admin_bar.contains(el)) {
							return true;
						}
					}
				}

			},
			transitions: [{
				name: 'global-page-transition',
				leave(data) {
					if (data.current.namespace === 'page-homepage.php') {
						return gsap.to(data.current.container, {
							opacity: 0,
							duration: 0.6,
							ease: "power1.out"
						});
					} else {
						let timeline = gsap.timeline()

						return timeline
							.to(data.current.container.querySelector('.js-content'), {
								y: 350,
								duration: 0.6,
								ease: "back.in(0.9)"
							})
							.to(data.current.container, {
								opacity: 0,
								duration: 0.6,
								ease: "circ.in"
							}, '<')
					}
				},
				beforeEnter(data) {
					$(document).trigger('ajax_navigation'); //header.js recup l'event pour fermer le menu

					gsap.set(data.next.container, {opacity: 0});
				},
				after(data) {
					if (data.next.namespace === 'page-homepage.php') {
						return gsap.to(data.next.container, {
							opacity: 1,
							duration: 0.6,
							ease: "power1.out"
						});
					} else {
						let timeline = gsap.timeline()

						return timeline
							.to(data.next.container, {
								opacity: 1,
								duration: 0.6,
								ease: "circ.out"
							})
							.from(data.next.container.querySelector('.js-content'), {
								y: 350,
								duration: 0.6,
								ease: "back.out(0.9)"
							}, '<')
					}
				}
			}]
		});

		barba.hooks.afterLeave((data) => {
			// Kill all GSAP ScrollTrigger because we need to refresh after we load the next page
			ScrollTrigger.getAll().forEach(t => t.kill());
		});
		barba.hooks.beforeEnter((data) => {
			window.scrollTo(0, 0);
			// TODO Bind contact modal to contact block
			window.init_module_for_new_page();

			// Set the css theme class
			let body = document.querySelector('body');
			let current_cssThemeClass = body.dataset.cssThemeClass;
			let next_cssThemeClass = data.next.container.dataset.cssThemeClass;
			if (current_cssThemeClass) {
				body.classList.remove(current_cssThemeClass);
			}
			if (next_cssThemeClass) {
				body.classList.add(next_cssThemeClass);
			}
			body.dataset.cssThemeClass = next_cssThemeClass;

			// Set the current menu item for css style
			let all_current_menu_item = document.querySelectorAll('.js-ajax-menuList-item-link.is-current');
			if (all_current_menu_item != null) {
				all_current_menu_item.forEach((item) => {
					item.classList.remove('is-current')
				});
			}
			let menuCurrentItemId = data.next.container.dataset.menuCurrentItemId;
			if (menuCurrentItemId > 0) {
				let future_current_menu_item = document.getElementById(menuCurrentItemId).querySelector('.js-ajax-menuList-item-link');
				future_current_menu_item.classList.add('is-current')
			}
		});
		barba.hooks.after((data) => {
			// Refresh ScrollTrigger
			ScrollTrigger.refresh();

			// This is to process javascript inside <script> tags
			// which would have been loaded in the new page content
			let js = data.next.container.querySelectorAll('script');
			if (js != null) {
				js.forEach((item) => {
					eval(item.innerHTML);
				});
			}

			// Autoplay video after barba js loaded the page
			let videos = document.querySelectorAll(".js-video");
			if (typeof videos != "undefined" && videos != null) {
				videos.forEach((video) => {
					if (video.hasAttribute('autoplay')) {
						video.play();
					}
				});
			}
		});
	},

	bindEvents: function() {
		document.querySelectorAll('.js-ajax-previous').forEach(ajaxPreviousButton => {
			ajaxPreviousButton.addEventListener('click', this.ajaxPrevious.bind(this));
		});
	},

	ajaxPrevious: function(e) {
		if (barba.history.previous) {
			history.back();
		}
	},

};

export default ajaxNav;
